/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */
import React from 'react';
import { decorate } from 'mobx';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Container, Icon } from 'semantic-ui-react';
import { gotoFn } from '@amzn/base-ui/dist/helpers/routing';

import KeyPairCreateForm from './parts/KeyPairCreateForm';

const iconStyle = { lineHeight: 1, height: '1em', margin: 0 };

class KeyPairCreate extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const goto = gotoFn(this);
    return (
      <Container className="mt3 animated fadeIn">
        {/* Breadcrumb */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px', fontSize: '0.9em', color: '#6b7280' }}>
          <button
            onClick={() => goto('/key-pair-management')}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--rmit-blue)', fontWeight: 500, padding: 0, fontFamily: 'inherit', fontSize: 'inherit' }}
          >
            SSH Keys
          </button>
          <Icon name="angle right" style={iconStyle} />
          <span style={{ color: '#111827', fontWeight: 600 }}>Create Key</span>
        </div>

        {/* Form card */}
        <div className="workspace-card">
          <div className="workspace-card-accent" style={{ background: 'var(--rmit-blue)' }} />
          <div className="workspace-card-content">
            <KeyPairCreateForm onCancel={() => goto('/key-pair-management')} />
          </div>
        </div>
      </Container>
    );
  }
}

decorate(KeyPairCreate, {});

export default inject()(withRouter(observer(KeyPairCreate)));
